// extracted by mini-css-extract-plugin
export default {"smallWidgetsArea":"smallWidgetsArea_smallWidgetsArea__1DJS0","addWidgetButton":"smallWidgetsArea_addWidgetButton__ig3F0"};